import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function PedidosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_COTIZACIONES = process.env.REACT_APP_URL_COTIZACIONES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_COTIZACION = process.env.REACT_APP_URL_ARTICULOS_COTIZACION;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_TIPOS_TELAS = process.env.REACT_APP_URL_TIPOS_TELAS;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_AREAS_CLIENTES = process.env.REACT_APP_URL_AREAS_CLIENTES;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;
  const URL_VARIANTES_TALLAS = process.env.REACT_APP_URL_VARIANTES_TALLAS;

  let hoy = new Date()
  // let inicio = new Date()
  // inicio.setDate(inicio.getDate()-60);

  let endDate   = moment(hoy).format("YYYY-MM-DD");
  // let startDate   = moment(inicio).format("YYYY-MM-DD");

  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [cotizaciones, setCotizaciones] = useState([]);
  const [cotizacionesCliente, setCotizacionesCliente] = useState([]);
  const [selectedCotizacion, setSelectedCotizacion] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [pedidoCliente, setPedidoCliente] = useState("");
  // (2026-09) Subcliente, texto libre, "NA" por default
  const [subCliente, setSubCliente] = useState("NA");
  // (2026-07) tipo de pedido
  const [selectedTipo, setSelectedTipo] = useState("Por definir");
  const [colaboradores, setColaboradores] = useState([]);
  const [comprador, setComprador] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [idArt, setIdArt] = useState("");
  const [idArtPdr, setIdArtPdr] = useState("");
  const [codigoCliente, setCodigoCliente] = useState("NA");
  const [codigo, setCodigo] = useState("");
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);
  const [value, setValue] = useState("");
  const [descuento, setDescuento] = useState(0);
  const [precio, setPrecio] = useState();
  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedad, setSelectedSociedad] = useState("");
  const [areasClientesOptions, setAreasClientesOptions] = useState([]);
  const [sucursalesClientes, setSucursalesClientes] = useState([]);
  // const [selectedSociedad, setSelectedSociedad] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(endDate);
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [condiciones, setCondiciones] = useState("");
  const [observacionesMarca, setObservacionesMarca] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  const [pendFechaConf, setPendFechaConf] = useState("");
    const [nombreFirma, setNombreFirma] = useState("");
  const [esOtroNombre, setEsOtroNombre] = useState(false);
  const [nombreFirmaOtro, setNombreFirmaOtro] = useState("");
    const [puestoFirma, setPuestoFirma] = useState("");
  const [esOtroPuesto, setEsOtroPuesto] = useState(false);
  const [puestoFirmaOtro, setPuestoFirmaOtro] = useState("");
  const [nombreComprador, setNombreComprador] = useState("");
  const [puestoComprador, setPuestoComprador] = useState("");
  const [impuestos, setImpuestos] = useState("Si");

  const [telas, setTelas] = useState([]);
  const [tiposTelas, setTiposTelas] = useState([]);
  const [modalExplosiones, setModalExplosiones] = useState(false);
  const toggleExplosiones = () => setModalExplosiones(!modalExplosiones);
  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      areasClientes: "",
      sucursales: "",
      articulos: "",
      articulosNombre: "",
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      precio: 0,
      tela: "",
      proveedorTela: "",
      composicion: "",
      observacionesArticulo: "NA",
      descuento: 0,
      total: 0,
      tc: [],
      totalArt: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  Promise.all([
    axios.get(URL_ARTICULOS, { headers }),
    axios.get(URL_COLORES, { headers }),
    axios.get(URL_TALLAS, { headers }),
    axios.get(URL_CLIENTES, { headers }),
    axios.get(URL_MARCAS, { headers }),
    axios.get(`${URL_COTIZACIONES}Abiertas`, { headers }),
    axios.get(URL_COLABORADORES, { headers }),
    axios.get(URL_COMPRADORES, { headers }),
    axios.get(URL_EMPRESAS, { headers }),
    axios.get(URL_TELAS, { headers }),
    axios.get(URL_SOCIEDADES, { headers }),
    axios.get(URL_VARIANTES_TALLAS, { headers }),
    axios.get(URL_TIPOS_TELAS, { headers }),
  ])
    .then(
      ([
        resArticulos,
        resColores,
        resTallas,
        resClientes,
        resMarcas,
        resCotizaciones,
        resColaboradores,
        resCompradores,
        resEmpresas,
        resTelas,
        resSociedades,
        resVariantesTallas,
        resTiposTelas,
      ]) => {
        setArticulos(resArticulos.data);
        setColores(resColores.data);
        setTallas(resTallas.data);
        setClientes(resClientes.data);
        setMarcas(resMarcas.data);
        setCotizaciones(resCotizaciones.data);
        setColaboradores(resColaboradores.data);
        setCompradores(resCompradores.data);
        setEmpresas(resEmpresas.data);
        setTelas(resTelas.data);
        setSociedades(resSociedades.data);
        setVariantesTallas(resVariantesTallas.data);
        setTiposTelas(resTiposTelas.data);
      }
    )
    .catch((err) => {
      console.error("Error al cargar catálogos:", err);
    });
}, []);

useEffect(() => {
  if (!value?._id) {
    setCotizacionesCliente([]);
    setSelectedCotizacion(""); // limpia cotización si cambia cliente
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_COTIZACIONES}Abiertas`, { headers })
    .then((res) => {
      const todas = res.data;
const filtradas = todas.filter((c) => {
  const cotCliente = c.clientes?.[0];
  const cotClienteId = typeof cotCliente === "string" ? cotCliente : cotCliente?._id;
  return String(cotClienteId) === String(value._id);
});


      setCotizacionesCliente(filtradas);
    })
    .catch((err) => {
      console.error("Error al filtrar cotizaciones del cliente:", err);
    });
}, [value]);

useEffect(() => {
  if (!selectedCotizacion) return;

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_ARTICULOS_COTIZACION}/cotizaciones/${selectedCotizacion}`, { headers })
    .then((resArt) => {
      cargarArticulosDesdeCotizacion(resArt.data);
    })
    .catch((err) =>
      console.error("Error al cargar artículos de cotización:", err)
    );
}, [selectedCotizacion]);

useEffect(() => {
  if (!value?._id) {
    setSucursalesClientes([]); // o el estado que uses para guardar las sucursales
    return;
  }

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  axios
    .get(`${URL_SUCURSALES}/clientes/${value._id}`, { headers })
    .then((res) => {
      setSucursalesClientes(res.data); // Actualiza tu estado de sucursales aquí
    })
    .catch((err) => {
      console.error("Error al cargar sucursales del cliente:", err);
    });
}, [value]);

useEffect(() => {
  ActualizaTotales();
}, [inputFields]);

useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  if (!value?._id) {
    setAreasClientesOptions([]);
    return;
  }

  axios
    .get(`${URL_AREAS_CLIENTES}/cliente/${value._id}`, { headers })
    .then((res) => {
      setAreasClientesOptions(res.data || []);
    })
    .catch((err) => {
      console.log(err);
      setAreasClientesOptions([]);
    });
}, [value?._id]);

const filter = createFilterOptions();

const [modalNuevaTalla, setModalNuevaTalla] = useState(false);
const [nuevaTallaNombre, setNuevaTallaNombre] = useState("");
const [renglonNuevaTalla, setRenglonNuevaTalla] = useState(null);
const [savingTalla, setSavingTalla] = useState(false);
const [variantesTallas, setVariantesTallas] = useState([]);
const [variante, setVariante] = useState("");

const [modalNuevoColor, setModalNuevoColor] = useState(false);
const [nuevoColorNombre, setNuevoColorNombre] = useState("");
const [renglonNuevoColor, setRenglonNuevoColor] = useState(null);
const [savingColor, setSavingColor] = useState(false);

const openNuevoColor = (renglonId) => {
  setRenglonNuevoColor(renglonId);
  setNuevoColorNombre("");
  setModalNuevoColor(true);
};

const guardarNuevoColor = async () => {
  const nombre = String(nuevoColorNombre || "").trim();
  if (!nombre) return;

  try {
    setSavingColor(true);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const res = await axios.post(URL_COLORES, { name: nombre }, { headers });
    const nuevo = res.data;

    setColores((prev) => {
      const exists = prev.some((c) => String(c?._id) === String(nuevo?._id));
      return exists ? prev : [...prev, nuevo];
    });

    if (renglonNuevoColor && nuevo?._id) {
      const idStr = String(nuevo._id);
      setInputFields((prev) =>
        prev.map((f) => {
          if (f.id !== renglonNuevoColor) return f;
          const sel = Array.isArray(f.selectedColores) ? f.selectedColores : [];
          if (sel.includes(idStr)) return f;
          const next = [...sel, idStr];
          updateSelectedColores(f.id, next);
          return f;
        })
      );
    }

    setModalNuevoColor(false);
    setNuevoColorNombre("");
    setRenglonNuevoColor(null);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo dar de alta el color.", "error");
  } finally {
    setSavingColor(false);
  }
};

// ===== Tela: selección desde catálogo + alta inline =====
const handleSeleccionTela = (renglonId, nombreTela) => {
  const telaObj = telas.find((t) => t.nombre === nombreTela);
  setInputFields((prev) =>
    prev.map((f) =>
      f.id === renglonId
        ? {
            ...f,
            tela: nombreTela,
            composicion: telaObj?.composicion || "",
          }
        : f
    )
  );
};

const [modalNuevaTela, setModalNuevaTela] = useState(false);
const [renglonNuevaTela, setRenglonNuevaTela] = useState(null);
const [savingTela, setSavingTela] = useState(false);
const [nuevaTela, setNuevaTela] = useState({
  nombre: "",
  composicion: "",
  tipoTela: "",
});

const openNuevaTela = (renglonId) => {
  setRenglonNuevaTela(renglonId);
  setNuevaTela({ nombre: "", composicion: "", tipoTela: "" });
  setModalNuevaTela(true);
};

const guardarNuevaTela = async () => {
  const nombre = String(nuevaTela.nombre || "").trim();
  const composicion = String(nuevaTela.composicion || "").trim();
  const tipoTela = String(nuevaTela.tipoTela || "").trim();
  if (!nombre || !composicion || !tipoTela) {
    Swal.fire("Atención", "Nombre, composición y tipo son requeridos.", "warning");
    return;
  }
  try {
    setSavingTela(true);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const body = {
      nombre,
      composicion,
      descripcion: nombre,
      unidad: "MT",
      ancho: 0,
      peso: 0,
      rendimiento: 0,
      tiposTelas: tipoTela,
      costo: 0,
      venta: 0,
      observaciones: "NA",
    };
    const res = await axios.post(URL_TELAS, body, { headers });
    const creada = res.data;
    setTelas((prev) => {
      const exists = prev.some((t) => String(t._id) === String(creada._id));
      return exists ? prev : [...prev, creada];
    });
    if (renglonNuevaTela) {
      setInputFields((prev) =>
        prev.map((f) =>
          f.id === renglonNuevaTela
            ? { ...f, tela: creada.nombre, composicion: creada.composicion }
            : f
        )
      );
    }
    setModalNuevaTela(false);
    setRenglonNuevaTela(null);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo dar de alta la tela.", "error");
  } finally {
    setSavingTela(false);
  }
};

const openNuevaTalla = async (renglonId, nombre = "") => {
  setRenglonNuevaTalla(renglonId);
  setNuevaTallaNombre(String(nombre || "").trim());
  // setNuevaTallaVariante("");
  await fetchVariantesTallas(); // ✅ trae las nuevas variantes
  setModalNuevaTalla(true);
};

const guardarNuevaTalla = async () => {
  const nombre = String(nuevaTallaNombre || "").trim();
  if (!nombre) return;

  try {
    setSavingTalla(true);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // (2026-07) La variante NO es obligatoria (igual que TallasCreate): si no se
    // eligió una variante válida, se manda un arreglo vacío. Antes se mandaba
    // [variante] con variante="" → el backend rechazaba (no es ObjectId).
    const variantesArray =
      variante && variante !== "0" ? [variante] : [];
    const res = await axios.post(
      URL_TALLAS,
      { name: nombre, variantesTallas: variantesArray },
      { headers }
    );

    const nueva = res.data; // idealmente retorna el objeto creado

    // 1) actualizar catálogo global en caliente (sin refresh)
    setTallas((prev) => {
      const exists = prev.some((t) => String(t?._id) === String(nueva?._id));
      return exists ? prev : [...prev, nueva];
    });

    // 2) agregarla también al renglón actual del pedido
    if (renglonNuevaTalla) {
      addTallaToRenglon(renglonNuevaTalla, nueva);
    }

    setModalNuevaTalla(false);
    setNuevaTallaNombre("");
    setRenglonNuevaTalla(null);
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "No se pudo dar de alta la talla.", "error");
  } finally {
    setSavingTalla(false);
  }
};

const fetchVariantesTallas = async () => {
  try {
    const res = await axios.get(URL_VARIANTES_TALLAS, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });
    setVariantesTallas(res.data || []);
  } catch (err) {
    console.log(err);
  }
};

  // (2026-10) Enter en un campo ya no guarda el pedido a medio capturar; solo
  // se guarda con el botón. En observaciones (textarea) Enter sigue siendo
  // salto de línea y sobre un botón sigue funcionando.
  const evitaGuardarConEnter = (e) => {
    if (e.key !== "Enter") return;
    const t = e.target;
    if (t.tagName === "TEXTAREA" || t.tagName === "BUTTON") return;
    e.preventDefault();
  };

  const savePedido = async (event) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  let inicio = new Date(fecha_cancelacion);
  let bla = inicio.setDate(inicio.getDate() - 60);
  let fechaStatus = moment(bla).format("YYYY-MM-DD");

  let totalPedido = inputFields.length + inputFieldsTela.length;
    const nombreFinal = nombreFirma === "Otro" ? nombreFirmaOtro : nombreFirma;
    const puestoFinal = puestoFirma === "Otro" ? puestoFirmaOtro : puestoFirma;
  try {
    const { data: pedidoCreado } = await axios.post(
      URL_PEDIDOS,
      {
        fecha,
        fechaCreacion: endDate,
        resurtido: "Si",
        tipo: selectedTipo || "Por definir",
        empresas: selectedEmpresa,
        clientes: value._id,
        marcas: selectedMarca,
        colaboradores: selectedColaborador,
        fecha_cancelacion,
        fecha_confirmacion: fecha_cancelacion,
        total_general,
        total_piezas,
        compradores: "6776c839c763d45da2f0f5b7",
        observaciones,
        condiciones,
        observacionesMarca,
        pedidoCliente,
        subCliente: String(subCliente || "").trim() || "NA",
        surtido: 0,
        pendiente_surtir: total_piezas,
        confirmacionPedido: "No",
        status: "Abierto",
        fechaEstCodigos: fechaStatus,
        fechaEstFicha: fechaStatus,
        fechaEstAuditoria: fechaStatus,
        fechaEstMuestraFit: fechaStatus,
        fechaEstMuestraConfirmacion: fechaStatus,
        fechaEstEtiquetas: fechaStatus,
        fechaRealCodigos: fechaStatus,
        fechaRealFicha: fechaStatus,
        fechaRealAuditoria: fechaStatus,
        fechaRealMuestraFit: fechaStatus,
        fechaRealMuestraConfirmacion: fechaStatus,
        fechaRealEtiquetas: fechaStatus,
        autorizacionFitFecha: fechaStatus,
        autorizacionCostosFecha: fechaStatus,
        autorizacionDisenoFecha: fechaStatus,
        autorizacionCalidadFecha: fechaStatus,
        autorizacionPloterFecha: fechaStatus,
        autorizacionPloterDisenoFecha: fechaStatus,
        autorizacionSurtirFecha: fechaStatus,
        autorizacionFitColaborador: "613a9434225bce3df050c220",
        autorizacionCostosColaborador: "613a9434225bce3df050c220",
        autorizacionDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionCalidadColaborador: "613a9434225bce3df050c220",
        autorizacionPloterColaborador: "613a9434225bce3df050c220",
        autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
        autorizacionSurtirColaborador: "613a9434225bce3df050c220",
        descuento,
        pendFechaConf: "Si",
        sociedades: "6775c905d688145c579d8393",
        cotizaciones: selectedCotizacion || null, // 👉 incluye cotización si existe

            nombreFirma: nombreFinal,
            puestoFirma: puestoFinal,
            nombreComprador,
            puestoComprador,
            impuestos,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    const idPedido = pedidoCreado._id;

    // 👉 Actualizar cotización
    if (selectedCotizacion) {
      axios.patch(
        `${URL_COTIZACIONES}/${selectedCotizacion}`,
        {
          status: "Pedido",
          pedidos: idPedido,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ).catch((err) =>
        console.error("Error al actualizar cotización:", err)
      );
    }

    // Guardar artículos del pedido
    for (const a of inputFields) {
      if (a.articulos !== "" && a.totalArt !== 0) {
        for (const b of a.tc) {
          await axios.post(
            URL_ARTICULOS_PEDIDO,
            {
              pedidos: idPedido,
              articulos: a.articulos,
              colores: b.colores,
              tallas: b.tallas,
              cantidad: parseFloat(b.cantidad),
              pendienteCortar: parseFloat(b.cantidad),
              cortado: 0,
              surtido: 0,
              pendiente_surtir: parseFloat(b.cantidad),
              cantidad_procesos: parseFloat(b.cantidad),
              precio: a.precio,
              tela: a.tela,
              proveedorTela: a.proveedorTela || "NA",
              composicion: a.composicion || "NA",
              observacionesArticulo: a.observacionesArticulo,
              descuento,
              total: a.total,
              codigoBarras: 0,
              precioEtiqueta,
              resurtido: "Si",
              codigoCliente,
              sociedades: "6775c905d688145c579d8393",
              areasClientes: a.areasClientes,
              sucursales: a.sucursales,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        }
      }
      totalPedido--;
    }

    // Puedes habilitar este bloque para guardar inputFieldsTela si los usas
    // for (const a of inputFieldsTela) {
    //   if (a.idTela !== "" && a.idColor !== "" && a.cantidad > 0) {
    //     await axios.post(URL_EXPLOSION_GLOBAL, {
    //       articulos: idArt,
    //       pedidos: idPedido,
    //       telas: a.idTela,
    //       colores: a.idColor,
    //       cantidad: a.cantidad,
    //       tipo: "Tela",
    //       observaciones: a.observaciones,
    //     }, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
    //     totalPedido--;
    //   }
    // }

    // Guardar log
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Pedido",
        detalle: `${value._id} ${total_general}`,
        user: user.id,
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // L94 (2026-06) — al guardar, abrir el PDF azul (PDFOCPorArea, bordados No) en ListadoPedidos
    localStorage.setItem("autoPDFPedido", pedidoCreado._id);
    Swal.fire("Good job!", `Creado con éxito, Pedido ${pedidoCreado.idPedido}`, `success`);
    setTimeout(() => {
      window.location.href = "/ListadoPedidos";
    }, 1500);
  } catch (error) {
    console.error("Error al crear pedido:", error);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response?.data || "Error desconocido"}`,
    });
    setValidaBoton(true);
  }
};

 const handleAddFields = () => {
  setInputFields((prevFields) => [
    ...prevFields,
    {
      id: uuidv4(),
      areasClientes: "",
      sucursales: "",
      articulos: "",
      articulosNombre: "",
      colores: "",
      arrayColoresArticulo: [],
      tallas: "",
      arrayTallasArticulo: [],
      cantidad: 0,
      precio: 0,
      tela: "NA",
      proveedorTela: "",
      composicion: "",
      observacionesArticulo: "NA",
      descuento: 0,
      total: 0,
      tc: [],
      totalArt: 0,
    },
  ]);
};

const handleRemoveFields = (id) => {
  setInputFields((prevFields) =>
    prevFields.length > 1
      ? prevFields.filter((field) => field.id !== id)
      : prevFields
  );
  ActualizaTotales()
};


function BuscaArticulo(id, selectedArticulo) {
  if (!selectedArticulo?._id) {
    handleChangeInputArticulo(id, "", 0, [], [], "", "", null);
    return;
  }

  const a = articulos.find(x => String(x._id) === String(selectedArticulo._id));
  if (!a) return;

  const idArticulo = a._id;
  const precio = a.venta || 0;
  const codigoCliente = a.codigoCliente || "";
  const codigo = `${a.codigo || ""} ${a.descripcion || ""}`.trim();
  const coloresArticulo = a.colores || [];
  const tallasArticulo = a.tallas || [];

  handleChangeInputArticulo(
    id,
    idArticulo,
    precio,
    coloresArticulo,
    tallasArticulo,
    codigoCliente,
    codigo,
    selectedArticulo // 👈 AQUI
  );
}

  // ordena: sin variante (0) -> con variante (1)
// luego por ordenTallas, y si ambos tienen variante y misma base, por la "variante" con orden natural
const sortTCByVariantAndOrder = (tc, ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"]) => {
  const norm = (s="") => s.toString().trim().toUpperCase();

  const baseOf = (name="") => {
    const n = norm(name);
    let best = null;
    for (const base of ordenTallas) {
      const nb = norm(base);
      if (n === nb || n.startsWith(nb + " ")) {
        if (!best || nb.length > norm(best).length) best = base;
      }
    }
    return best || name.toString().trim().split(/\s+/)[0];
  };

  const variantOf = (name="") => {
    const base = baseOf(name);
    const raw  = name.toString().trim();
    return raw.slice(base.length).trim(); // "" si no hay variante
  };

  return [...tc].sort((a, b) => {
    const baseA = baseOf(a.tallaNombre || "");
    const baseB = baseOf(b.tallaNombre || "");
    const hasVarA = variantOf(a.tallaNombre || "") !== "";
    const hasVarB = variantOf(b.tallaNombre || "") !== "";

    if (hasVarA !== hasVarB) return hasVarA ? 1 : -1; // sin variante primero

    const idxA = ordenTallas.indexOf(baseA);
    const idxB = ordenTallas.indexOf(baseB);
    const byBase = (idxA === -1 ? Infinity : idxA) - (idxB === -1 ? Infinity : idxB);
    if (byBase !== 0) return byBase;

    if (hasVarA && hasVarB && baseA === baseB) {
      const vA = variantOf(a.tallaNombre || "");
      const vB = variantOf(b.tallaNombre || "");
      const cmp = vA.localeCompare(vB, undefined, { numeric: true, sensitivity: "base" });
      if (cmp !== 0) return cmp;
    }

    return (a.colorNombre || "").localeCompare(b.colorNombre || "") ||
           (a.tallaNombre || "").localeCompare(b.tallaNombre || "", undefined, { numeric:true, sensitivity:"base" });
  });
};



// Helpers
const asId = (x) => (x != null ? String(x) : "");

const variantesMap = new Map(
  (variantesTallas || []).map((v) => [String(v._id), v.name || v.nombre || ""])
);

// selectedColorIds: array de ids de color seleccionados (strings)
// arrayTallas: catálogo de tallas del artículo (con posibles variantesTallas)
// coloresArticulo: catálogo de colores del artículo (puede estar vacío o sin el color elegido)
// coloresGlobal: catálogo global (el que usas en <Autocomplete options={colores || []}>)
// prevTC: para conservar cantidades si la combinación ya existía
function buildTCFromSelection(
  selectedColorIds = [],
  arrayTallas = [],
  coloresArticulo = [],
  coloresGlobal = [],
  prevTC = []
) {
  const tallasArray = Array.isArray(arrayTallas)
    ? arrayTallas
    : Object.values(arrayTallas || {});

  // Union de catálogos: prioriza nombres del catálogo global
  const unionColores = [
    ...(Array.isArray(coloresGlobal) ? coloresGlobal : []),
    ...(Array.isArray(coloresArticulo) ? coloresArticulo : []),
  ];
  const colorMap = new Map(
    unionColores.map((c) => [
      asId(c._id),
      { _id: asId(c._id), name: c.name || c.nombre || "" },
    ])
  );

  // Para conservar cantidades previas
  const prevMap = new Map(
    (prevTC || []).map((r) => [
      `${asId(r.colores)}|${asId(r.tallas)}|${r.tallaNombre}`,
      Number(r.cantidad) || 0,
    ])
  );

  const tc = [];
  for (const colorIdRaw of selectedColorIds) {
    const colorId = asId(colorIdRaw);
    const colorObj = colorMap.get(colorId) || { _id: colorId, name: "" }; // permite colores fuera del artículo

    for (const t of tallasArray) {
      const tId = asId(t._id);
      const baseName = t.name || t.nombre || "";
const variantesRaw = Array.isArray(t.variantesTallas) ? t.variantesTallas : [];

const getVarName = (v) => {
  // viene populado como objeto
  if (v && typeof v === "object") return (v.name || v.nombre || "").trim();

  // viene como ID string / ObjectId
  const id = String(v || "");
  return (variantesMap.get(id) || "").trim();
};

const variantesNombres = variantesRaw
  .map(getVarName)
  .filter(Boolean); // quita vacíos

if (variantesNombres.length > 0) {
  for (const varName of variantesNombres) {
    const tallaNombre = `${baseName} ${varName}`.trim();
    const key = `${colorId}|${tId}|${tallaNombre}`;
    const cantidad = prevMap.get(key) ?? 0;

    tc.push({
      colores: colorId,
      colorNombre: colorObj.name,
      tallas: tId,
      tallaNombre,
      cantidad,
    });
  }
} else {
  const tallaNombre = baseName;
  const key = `${colorId}|${tId}|${tallaNombre}`;
  const cantidad = prevMap.get(key) ?? 0;

  tc.push({
    colores: colorId,
    colorNombre: colorObj.name,
    tallas: tId,
    tallaNombre,
    cantidad,
  });
}
    }
  }

  return sortTCByVariantAndOrder(tc, ordenTallas);
}


const handleChangeInputArticulo = (
  id,
  idArticulo,
  precio,
  coloresArticulo,
  tallasArticulo,
  codigoCliente,
  codigo,
  articuloObj // 👈 nuevo
) => {
  setInputFields(prev =>
    prev.map(f => {
      if (f.id !== id) return f;

      return {
        ...f,
        articulos: idArticulo,
        articulosNombre: articuloObj, // 👈 ESTO HACE QUE SE VEA EN EL INPUT
        precio,
        codigoCliente,
        codigo,
        arrayColoresArticulo: coloresArticulo,
        arrayTallasArticulo: tallasArticulo,
      };
    })
  );
};


const updateSelectedColores = (inputFieldId, newSelectedIds) => {
  const normalized = (newSelectedIds || []).map(asId);

  setInputFields((prev) =>
    prev.map((f) => {
      if (f.id !== inputFieldId) return f;

      const tc = buildTCFromSelection(
        normalized,
        f.arrayTallasArticulo || [],
        f.arrayColoresArticulo || [],
        colores || [],         // catálogo global del Autocomplete
        f.tc || []             // conservar cantidades
      );

      // (Opcional) recalcular total del renglón
      const totalArt = tc.reduce((acc, it) => acc + (Number(it.cantidad) || 0), 0);
      const precio = Number(f.precio) || 0;
      const descuento = Number(f.descuento) || 0;
      const total = Number((totalArt * precio * (1 - descuento / 100)).toFixed(2));

      return { ...f, selectedColores: normalized, tc, totalArt, total };
    })
  );
};


const ActualizaTotales = (fields = inputFields) => {
  let totalPiezas = 0;
  let totalDinero = 0;

  fields.forEach((field) => {
    totalPiezas += parseFloat(field.totalArt) || 0;
    totalDinero += parseFloat(field.total) || 0;
  });

  setTotalPiezas(totalPiezas);
  setTotalGeneral(parseFloat(totalDinero.toFixed(2)));
};


// =========================
// Agregar talla faltante (solo en este pedido)
// - La agrega al catálogo de tallas del renglón (arrayTallasArticulo)
// - Re-genera tc para TODOS los colores seleccionados
// =========================
const addTallaToRenglon = (inputFieldId, tallaObj) => {
  if (!tallaObj || !tallaObj._id) return;

  setInputFields((prev) =>
    prev.map((f) => {
      if (f.id !== inputFieldId) return f;

      const exists = (f.arrayTallasArticulo || []).some(
        (t) => String(t?._id) === String(tallaObj._id)
      );
      if (exists) return f;

      const newTallas = [...(f.arrayTallasArticulo || []), tallaObj];

      // Si ya hay colores seleccionados, reconstruimos tc para que la nueva talla aplique a todos
      const tc = (f.selectedColores || []).length
        ? buildTCFromSelection(
            f.selectedColores || [],
            newTallas,
            f.arrayColoresArticulo || [],
            colores || [],
            f.tc || []
          )
        : (f.tc || []);

      const totalArt = tc.reduce((acc, it) => acc + (Number(it.cantidad) || 0), 0);
      const precio = Number(f.precio) || 0;
      const descuento = Number(f.descuento) || 0;
      const total = Number((totalArt * precio * (1 - descuento / 100)).toFixed(2));

      return { ...f, arrayTallasArticulo: newTallas, tc, totalArt, total };
    })
  );
};



  function explosiones() {
    
    setInputFieldsTela([
      {
        id: uuidv4(),
        idTela: "",
        idColor: "",
        cantidad: 0,
        observaciones: "NA",
      },
    ]);
    toggleExplosiones();
  }


  const handleRemoveFieldsTelas = (id) => {
    const values = [...inputFieldsTela];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsTela(values);
  };


const handleAddFieldsTelas = () => {
  setInputFieldsTela([
    ...inputFieldsTela,
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      observaciones: "NA",
    },
  ]);
};
const handleChangeInputTela = (id, event) => {
  const newInputFieldsTela = inputFieldsTela.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsTela(newInputFieldsTela);
};

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

const handleInputFieldChange = (id, fieldName, value) => {
  setInputFields((prevFields) => {
    const updatedFields = prevFields.map((field) => {
      if (field.id === id) {
        const updatedField = { ...field, [fieldName]: value };

        // Si cambia precio o descuento, recalcula total del artículo
        if (fieldName === "precio" || fieldName === "descuento") {
          const totalArt = parseFloat(updatedField.totalArt) || 0;
          const precio = parseFloat(updatedField.precio) || 0;
          const descuento = parseFloat(updatedField.descuento) || 0;

          updatedField.total = parseFloat(
            (totalArt * precio * (1 - descuento / 100)).toFixed(2)
          );
        }

        return updatedField;
      }
      return field;
    });

    // Llama a ActualizaTotales después de actualizar inputFields
    setTimeout(() => {
      ActualizaTotales(updatedFields);
    }, 0);

    return updatedFields;
  });
};

const handleChangeInputCantidad = (idField, idColor, idTalla, event) => {
  const nuevaCantidad = parseInt(event.target.value) || 0;

  setInputFields((prevFields) =>
    prevFields.map((field) => {
      if (field.id === idField) {
        const nuevaTC = field.tc.map((tcItem) => {
          if (tcItem.colores === idColor && tcItem.tallas === idTalla) {
            return { ...tcItem, cantidad: nuevaCantidad };
          }
          return tcItem;
        });

        const nuevoTotalArt = nuevaTC.reduce(
          (acc, item) => acc + (parseInt(item.cantidad) || 0),
          0
        );

        const precio = parseFloat(field.precio) || 0;
        const descuento = parseFloat(field.descuento) || 0;

        const nuevoTotal = parseFloat(
          (nuevoTotalArt * precio * (1 - descuento / 100)).toFixed(2)
        );

        return {
          ...field,
          tc: nuevaTC,
          totalArt: nuevoTotalArt,
          total: nuevoTotal,
        };
      }
      return field;
    })
  );

  ActualizaTotales();
};


function cargarArticulosDesdeCotizacion(articulosCot) {
  // helper para normalizar ids
  const asIdLocal = (v) => String(v?._id || v || "");

  const nuevosInputFields = (articulosCot || [])
    .map((item) => {
      // 1) Obtener artículo (usa el del item si viene populado; si no, busca en catálogo)
      const articuloFromItem = item?.articulos?.[0] || null;
      const articuloCatalogo =
        articulos?.find((a) => String(a?._id) === String(articuloFromItem?._id)) || null;

      const articulo = articuloFromItem || articuloCatalogo;
      if (!articulo?._id) return null;

      // 2) Colores / Tallas (prioriza lo de la cotización; si no existe, usa lo del artículo)
      const coloresSel = Array.isArray(item?.colores) && item.colores.length
        ? item.colores
        : (articulo.colores || []);

      const tallasSel = Array.isArray(item?.tallas) && item.tallas.length
        ? item.tallas
        : (articulo.tallas || []);

      // 3) selectedColores (para tu Autocomplete)
      const selectedColores = coloresSel.map((c) => asIdLocal(c));

      // 4) PrevTC con cantidades (si la cotización trae tc, aquí lo usamos)
      //    Soporta: item.tc o item.TC o item.tallasColores (por si lo nombraste diferente)
      const prevTCraw = item?.tc || item?.TC || item?.tallasColores || [];

      const prevTC = (Array.isArray(prevTCraw) ? prevTCraw : []).map((r) => ({
        colores: asIdLocal(r?.colores),
        tallas: asIdLocal(r?.tallas),
        tallaNombre: r?.tallaNombre || r?.talla?.name || r?.tallas?.[0]?.name || "",
        cantidad: Number(r?.cantidad) || 0,
      }));

      // 5) Construir tc FINAL conservando cantidades donde haya match
      //    (usa tu función existente buildTCFromSelection)
      const tc = buildTCFromSelection(
        selectedColores,
        tallasSel,
        coloresSel,
        colores || [],     // catálogo global de colores
        prevTC             // conserva cantidades de la cotización
      );

      // 6) Precio / descuento / totales
      const precio = Number(item?.precio ?? articulo?.venta ?? 0) || 0;
      const descuentoItem = Number(item?.descuento ?? 0) || 0;

      const totalArt = tc.reduce((acc, it) => acc + (Number(it.cantidad) || 0), 0);
      const total = Number((totalArt * precio * (1 - descuentoItem / 100)).toFixed(2));

      return {
        id: uuidv4(),
        articulos: articulo._id,
        codigo: `${articulo.codigo || ""} ${articulo.descripcion || articulo.nombre || ""}`.trim(),

        precio,
        descuento: descuentoItem,
        total,
        totalArt,

        // catálogos en el renglón
        coloresArticulo: coloresSel,
        tallasArticulo: tallasSel,
        arrayColoresArticulo: coloresSel,
        arrayTallasArticulo: tallasSel,

        // para el Autocomplete de colores
        selectedColores,

        // tabla talla-color con cantidades
        tc,

        // extras que ya usabas
        areasClientes: item?.areasClientes?.[0]?._id || "",
        sucursales: item?.sucursales?.[0]?._id || "",
        articulosNombre: articulo,
        tela: item?.tela,
        proveedorTela: item?.proveedorTela || "",
      };
    })
    .filter(Boolean);

  // setInputFields(nuevosInputFields);
  // ActualizaTotales(nuevosInputFields);
}
const sumCantidadByColor = (tc = [], colorId) =>
  tc.reduce((acc, a) => acc + (String(a.colores) === String(colorId) ? Number(a.cantidad) || 0 : 0), 0);

const fmtUSD = (n=0) =>
  new Intl.NumberFormat("en-US", { style:"currency", currency:"USD", maximumFractionDigits:2 })
    .format(Number(n)||0);

  const options2 = articulos.map((option) => {
    const junta =  option.codigo
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // L92 (2026-06) — flag para opción dinámica de Nombre Firma (fuera del JSX
  // porque el parser Flow no admite ![...].includes() inline)
  const NOMBRES_FIRMA_FIJOS = [
    "Alberto Penhos",
    "Alexander Penhos",
    "Ana Laura Barrios",
    "Emilio Penhos",
    "Enrique de la Cruz",
    "Erica Leal",
    "Luis Gabriel Sanchez",
    "Magali Nava",
    "Ma. Concepcion Perez",
    "Miguel Sanchez",
    "Mireya Balderas",
    "Nissim Mann",
    "Pedro Castellanos",
  ];
  const mostrarFirmaDinamica =
    !!nombreFirma &&
    nombreFirma !== "Otro" &&
    NOMBRES_FIRMA_FIJOS.indexOf(nombreFirma) === -1;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nuevo Pedido</h3>
          <Form onSubmit={savePedido} onKeyDown={evitaGuardarConEnter}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Empresa</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(e) => {
                    setSelectedEmpresa(e.target.value);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                {/* (2026-07) tipo de pedido */}
                <Label className="mr-sm-2">Tipo Entrega</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedTipo}
                  onChange={(e) => setSelectedTipo(e.target.value)}
                >
                  <option value="Por definir">Por definir</option>
                  <option value="Personalizado">Personalizado</option>
                  <option value="Granel">Granel</option>
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cliente</Label>
                <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      setValue(selectedCliente);
                
                      // 👇 AQUÍ SE AUTOSELECCIONA EL VENDEDOR
                      if (selectedCliente?.contacto) {
                        const colRaw = selectedCliente.contacto[0];
                        const colId =
                          typeof colRaw === "string" ? colRaw : colRaw?._id;
                        setSelectedColaborador(colId);
                        // L92 (2026-06) — Nombre Firma jala nombre+apellido del vendedor
                        const col =
                          colRaw && colRaw.nombre
                            ? colRaw
                            : colaboradores.find((c) => c._id === colId) ||
                              colRaw;
                        const nombreCompleto = `${col?.nombre || ""} ${
                          col?.apellido || ""
                        }`.trim();
                        if (nombreCompleto) {
                          setNombreFirma(nombreCompleto);
                          setEsOtroNombre(false);
                          setNombreFirmaOtro("");
                        }
                      } else {
                        setSelectedColaborador(""); // por si no trae vendedor
                      }
                       if (selectedCliente?.condicionesCotizacion) {
      setCondiciones(selectedCliente.condicionesCotizacion);
    } else {
      setCondiciones("");
    }
    setInputFields((prev) =>
      prev.map((item) => ({
        ...item,
        areasClientes: "",
      }))
    );
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField {...params} label="Selecciona" variant="outlined" />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>{option.nombre_comercial}</React.Fragment>
                    )}
                  />
              </Col>

              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    const idCol = e.target.value;
                    setSelectedColaborador(idCol);
                    // L92 (2026-06) — Nombre Firma jala nombre+apellido del vendedor
                    const col = colaboradores.find((c) => c._id === idCol);
                    if (col) {
                      const nombreCompleto = `${col.nombre || ""} ${
                        col.apellido || ""
                      }`.trim();
                      if (nombreCompleto) {
                        setNombreFirma(nombreCompleto);
                        setEsOtroNombre(false);
                        setNombreFirmaOtro("");
                      }
                    }
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.nombre} {a.apellido}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={2}>
  <Label>Cotizacion (Opcional)</Label>
  <Input
    type="select"
    disabled={!value?._id}
    value={selectedCotizacion}
    onChange={(e) => {
      const cotizacionId = e.target.value;
      setSelectedCotizacion(cotizacionId);

      const cotizacionSeleccionada = cotizacionesCliente.find(
        (c) => c._id === cotizacionId
      );

      if (cotizacionSeleccionada) {
        setCondiciones(cotizacionSeleccionada.condiciones || "");
      } else {
        setCondiciones("");
      }
    }}
  >
    <option value="">Selecciona</option>
    {cotizacionesCliente
      .sort((a, b) => (a.idCotizacion > b.idCotizacion ? 1 : -1))
      .map((a) => (
        <option key={a._id} value={a._id}>
          {a.idCotizacion}
        </option>
      ))}
  </Input>
</Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label>Fecha Entrega</Label>
                <Input
                  type="date"
                  placeholder="Fecha Entrega"
                  value={fecha_cancelacion}
                  required
                  onChange={(e) => {
                    setFechaCancelacion(e.target.value);
                    let inicio = new Date(e.target.value);
                    let bla = inicio.setDate(inicio.getDate() - 41);
                    setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"));
                  }}
                />
              </Col>
              <Col md={1}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Pedido Cliente
                </Label>
                <Input
                  type="text"
                  placeholder="Pedido"
                  value={pedidoCliente}
                  required
                  onChange={(e) => {
                    setPedidoCliente(e.target.value);
                  }}
                />
              </Col>

              <Col md={1}>
                <Label className="mr-sm-2">Subcliente</Label>
                <Input
                  type="text"
                  placeholder="Subcliente"
                  value={subCliente}
                  onChange={(e) => setSubCliente(e.target.value)}
                />
              </Col>

              <Col md={1}>
                                            <Label>Impuestos</Label>
                                            <Input
                                              type="select"
                                              // placeholder="Puesto Comprador"
                                              value={impuestos}
                                              required
                                              onChange={(e) => {
                                                setImpuestos(e.target.value);
                                              }}
                                            >
                                              <option value="Si">Si</option>
                                              <option value="No">No</option>
                                            </Input>
                                          </Col>
              
               {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones Marca
                </Label>
                <Input
                  type="text"
                  placeholder="ObservacionesMarca"
                  value={observacionesMarca}
                  required
                  onChange={(e) => {
                    setObservacionesMarca(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={2}>
                <Label className="mr-sm-2">Marca</Label>
                <div style={{ display: "flex", gap: 4 }}>
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedMarca}
                    required
                    onChange={(e) => {
                      setSelectedMarca(e.target.value);
                    }}
                    style={{ flex: 1 }}
                  >
                    <option value="0">Selecciona</option>
                    {marcas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                  {/* L34 (2026-06) — Alta inline de marca */}
                  <Button
                    type="button"
                    size="sm"
                    color="success"
                    title="Crear nueva marca"
                    onClick={async () => {
                      const { value: nombreMarca } = await Swal.fire({
                        title: "Nueva Marca",
                        input: "text",
                        inputLabel: "Nombre de la marca",
                        inputPlaceholder: "Ej. MONARCH",
                        showCancelButton: true,
                        confirmButtonText: "Guardar",
                        cancelButtonText: "Cancelar",
                        inputValidator: (v) => {
                          if (!v || !String(v).trim()) return "Pon el nombre";
                          const existe = marcas.find(
                            (m) =>
                              (m?.name || "").trim().toLowerCase() ===
                              String(v).trim().toLowerCase()
                          );
                          if (existe) return "Esa marca ya existe";
                          return null;
                        },
                      });
                      if (!nombreMarca) return;
                      try {
                        const headers = {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        };
                        const { data: nueva } = await axios.post(
                          URL_MARCAS,
                          { name: String(nombreMarca).trim() },
                          { headers }
                        );
                        // refrescar lista + autoseleccionar
                        const { data: all } = await axios.get(URL_MARCAS, {
                          headers,
                        });
                        setMarcas(all);
                        const creada =
                          (all || []).find(
                            (m) =>
                              (m?.name || "").trim().toLowerCase() ===
                              String(nombreMarca).trim().toLowerCase()
                          ) || nueva;
                        if (creada?._id) setSelectedMarca(creada._id);
                        Swal.fire({
                          icon: "success",
                          title: "Marca creada",
                          timer: 1200,
                          showConfirmButton: false,
                        });
                      } catch (err) {
                        Swal.fire(
                          "Error",
                          err?.response?.data?.message ||
                            "No se pudo crear la marca",
                          "error"
                        );
                      }
                    }}
                    style={{ height: 32, marginTop: 4 }}
                  >
                    <i className="fas fa-plus"></i>
                  </Button>
                </div>
              </Col>
{/* <Col md={2}>
  <Label>Nombre Firma</Label>
  <Input
    type="select"
    value={nombreFirma}
    required
    onChange={(e) => {
      const value = e.target.value;
      setNombreFirma(value);

      if (value === "Otro") {
        setEsOtroNombre(true);
      } else {
        setEsOtroNombre(false);
        setNombreFirmaOtro("");
      }
    }}
  >
    <option value="">Selecciona</option>
    {mostrarFirmaDinamica && (
      <option value={nombreFirma}>{nombreFirma}</option>
    )}
    <option value="Alberto Penhos">Alberto Penhos</option>
    <option value="Alexander Penhos">Alexander Penhos</option>
    <option value="Ana Laura Barrios">Ana Laura Barrios</option>
    <option value="Emilio Penhos">Emilio Penhos</option>
    <option value="Enrique de la Cruz">Enrique de la Cruz</option>
    <option value="Erica Leal">Erica Leal</option>
    <option value="Luis Gabriel Sanchez">Luis Gabriel Sanchez</option>
    <option value="Magali Nava">Magali Nava</option>
    <option value="Ma. Concepcion Perez">Ma. Concepcion Perez</option>
    <option value="Miguel Sanchez">Miguel Sanchez</option>
    <option value="Mireya Balderas">Mireya Balderas</option>
    <option value="Nissim Mann">Nissim Mann</option>
    <option value="Pedro Castellanos">Pedro Castellanos</option>
    <option value="Otro">Otro</option>
  </Input>

  {esOtroNombre && (
    <Input
      type="text"
      placeholder="Escribe el nombre"
      value={nombreFirmaOtro}
      required
      className="mt-2"
      onChange={(e) => setNombreFirmaOtro(e.target.value)}
    />
  )}
</Col> */}


               <Col md={2}>
  <Label>Puesto Firma</Label>
  <Input
    type="select"
    value={puestoFirma}
    required
    onChange={(e) => {
      const value = e.target.value;
      setPuestoFirma(value);

      if (value === "Otro") {
        setEsOtroPuesto(true);
      } else {
        setEsOtroPuesto(false);
        setPuestoFirmaOtro("");
      }
    }}
  >
    <option value="">Selecciona</option>
    <option value="Administrativo Ventas">Administrativo Ventas</option>
    <option value="Director General">Director General</option>
    <option value="Director Logistica">Director Logistica</option>
    <option value="Director Produccion">Director Produccion</option>
    <option value="Director Ventas">Director Ventas</option>
    <option value="Ejecutivo Ventas">Ejecutivo Ventas</option>
    <option value="Otro">Otro</option>
  </Input>

  {esOtroPuesto && (
    <Input
      type="text"
      placeholder="Escribe el puesto"
      value={puestoFirmaOtro}
      required
      className="mt-2"
      onChange={(e) => setPuestoFirmaOtro(e.target.value)}
    />
  )}
</Col>
                                            <Col md={2}>
                                            <Label>Nombre Comprador</Label>
                                            <Input
                                              type="text"
                                              placeholder="Nombre Comprador"
                                              value={nombreComprador}
                                              required
                                              onChange={(e) => {
                                                setNombreComprador(e.target.value);
                                              }}
                                            />
                                          </Col>
                                           <Col md={2}>
                                            <Label>Puesto Comprador</Label>
                                            <Input
                                              type="text"
                                              placeholder="Puesto Comprador"
                                              value={puestoComprador}
                                              required
                                              onChange={(e) => {
                                                setPuestoComprador(e.target.value);
                                              }}
                                            />
                                          </Col>

            </Row>
            <Row>
                                          <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones (Monarch)
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
                                          <Col md={12}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Condiciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Condiciones"
                  value={condiciones}
                  required
                  onChange={(e) => {
                    setCondiciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            <br />
            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Sucursal</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Area</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Buscar</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div
                key={inputField.id}
                style={{
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "1rem",
                  marginBottom: "1rem",
                }}
              >
                {/* Fila principal del artículo */}
                <Row className="align-items-center mb-2">
                  <Col md={2}>
                    <Input
                      type="select"
                      value={inputField.sucursales}
                      required
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "sucursales",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona sucursal</option>
                      {sucursalesClientes
                      .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                      .map((suc) => (
                        <option key={suc._id} value={suc._id}>
                          {suc.alias}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      type="select"
                      required
                      value={inputField.areasClientes}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "areasClientes",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Selecciona área</option>
                      {areasClientesOptions
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((area) => (
                        <option key={area._id} value={area._id}>
                          {area.nombre || area.name}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Autocomplete
  size="small"
  value={inputField.articulosNombre || null}
  onChange={(event, selectedArticulo) =>
    BuscaArticulo(inputField.id, selectedArticulo)
  }
  options={options2.sort((a,b) => -b.firstLetter.localeCompare(a.firstLetter))}
  groupBy={(option) => option.firstLetter}
  getOptionLabel={(option) => option?.junta || ""}
  isOptionEqualToValue={(option, value) =>
    String(option?._id) === String(value?._id)
  }
  renderInput={(params) => (
    <TextField {...params} label="Selecciona" variant="outlined" />
  )}
/>
                  </Col>
                  <Col md={2}>
                    <Input
                      name="totalArt"
                      type="number"
                      placeholder="Piezas"
                      value={inputField.totalArt}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      name="precio"
                      type="number"
                      required
                      placeholder="Precio"
                      value={inputField.precio}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "precio",
                          parseFloat(e.target.value) || 0
                        )
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      name="total"
                      type="number"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                    />
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabIndex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      color="info"
                      onClick={handleAddFields}
                      tabIndex="-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>

                {/* Segunda fila: Tela / Prov. Tela / Observaciones */}
                <Row className="mb-2">
                  <Col md={4}>
                    <Label className="mb-1" style={{ fontSize: "0.8rem" }}>
                      Tela
                      {inputField.composicion ? (
                        <span className="text-muted">
                          {" · "}
                          {inputField.composicion}
                        </span>
                      ) : null}
                    </Label>
                    <div
                      style={{
                        display: "flex",
                        gap: 4,
                        alignItems: "stretch",
                      }}
                    >
                      <Input
                        name="tela"
                        type="select"
                        value={inputField.tela || ""}
                        onChange={(e) =>
                          handleSeleccionTela(inputField.id, e.target.value)
                        }
                        style={{ flex: 1, minWidth: 0 }}
                      >
                        <option value="">Selecciona</option>
                        {/* (2026-10) las telas dadas de baja no se ofrecen;
                            solo se deja la que el renglón ya traiga */}
                        {telas
                          .filter(
                            (t) =>
                              t.is_active !== "No" || t.nombre === inputField.tela
                          )
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((t) => (
                            <option value={t.nombre} key={t._id}>
                              {t.nombre}
                            </option>
                          ))}
                      </Input>
                      <Button
                        color="success"
                        title="Dar de alta tela"
                        onClick={() => openNuevaTela(inputField.id)}
                        style={{ padding: "0 10px", flexShrink: 0 }}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </div>
                  </Col>
                  <Col md={4}>
                    <Label className="mb-1" style={{ fontSize: "0.8rem" }}>
                      Prov. Tela
                    </Label>
                    <Input
                      name="proveedorTela"
                      type="text"
                      placeholder="Prov. Tela"
                      value={inputField.proveedorTela || ""}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "proveedorTela",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="mb-1" style={{ fontSize: "0.8rem" }}>
                      Observaciones
                    </Label>
                    <Input
                      name="observacionesArticulo"
                      type="text"
                      placeholder="Observaciones"
                      value={inputField.observacionesArticulo || ""}
                      onChange={(e) =>
                        handleInputFieldChange(
                          inputField.id,
                          "observacionesArticulo",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                </Row>

<Row>
  <Col md={12}>
{/* Selector de colores para ESTE inputField */}
<Autocomplete
  multiple
  disableCloseOnSelect
  options={colores || []}
  // options={inputField.arrayColoresArticulo || []}

  // v4: cómo mostrar el texto
  getOptionLabel={(opt) =>
    (opt?.name?.trim?.() || opt?.nombre?.trim?.() || "")
  }

  // v4: comparador correcto
  getOptionSelected={(opt, val) => String(opt?._id) === String(val?._id)}

  // value: convierte ids -> objetos de options
  value={(colores || []).filter(c =>
  // value={(inputField.arrayColoresArticulo || []).filter(c =>
    (inputField.selectedColores || []).includes(String(c._id))
  )}

  // onChange: guarda solo los _id en tu estado
  onChange={(e, values) =>
    updateSelectedColores(inputField.id, values.map(v => String(v._id)))
  }

  // v4: firma (option, state). Usamos state.selected
  renderOption={(option, { selected }) => (
    <React.Fragment>
      <input
        type="checkbox"
        readOnly
        checked={!!selected}
        style={{ marginRight: 12 }}
      />
      <span style={{ color: "#111", WebkitTextFillColor: "#111" }}>
        {option?.name?.trim?.() || option?.nombre?.trim?.() || ""}
      </span>
    </React.Fragment>
  )}

  renderInput={(params) => (
    <TextField {...params} label="Colores a mostrar" placeholder="Selecciona..." />
  )}
/>


{/* Botoncitos útiles */}
<div className="mb-2">
  {/* <Button
    size="sm"
    onClick={() =>
      updateSelectedColores(
        inputField.id,
        colores.map(c => c._id)
        // inputField.arrayColoresArticulo.map(c => c._id)
      )
    }
  >
    Seleccionar todos
  </Button>{" "} */}
  <Button
    size="sm"
    color="secondary"
    onClick={() => updateSelectedColores(inputField.id, [])}
  >
    Limpiar
  </Button>{" "}
  <Button
    size="sm"
    color="success"
    onClick={() => openNuevoColor(inputField.id)}
  >
    <i className="fas fa-plus"></i> Nuevo color
  </Button>
</div>

{/* Agregar talla faltante (aplica a TODOS los colores seleccionados) */}
<div className="mb-2" style={{ maxWidth: 420 }}>
<Autocomplete
  key={`add-talla-${inputField.id}-${(inputField.arrayTallasArticulo || []).length}`}
  size="small"
  value={null}
  options={(tallas || []).filter(
    (t) =>
      !(inputField.arrayTallasArticulo || []).some(
        (x) => String(x?._id) === String(t?._id)
      )
  )}

  // 🔥 agrega opción "Dar de alta"
  filterOptions={(options, params) => {
    const filtered = filter(options, params);
    const inputValue = String(params.inputValue || "").trim();

    if (inputValue) {
      const alreadyExists = options.some((opt) => {
        const base = String(opt?.name || opt?.nombre || opt?.idTalla || "").trim().toLowerCase();
        return base === inputValue.toLowerCase();
      });

      if (!alreadyExists) {
        filtered.push({
          inputValue,
          title: `Dar de alta "${inputValue}"`,
        });
      }
    }

    return filtered;
  }}

  getOptionLabel={(opt) => {
    // cuando es el "create option"
    if (typeof opt === "string") return opt;
    if (opt?.inputValue) return opt.inputValue;

    const base =
      String(opt?.name || opt?.nombre || "").trim() ||
      String(opt?.idTalla || "").trim();

    const vars = Array.isArray(opt?.variantesTallas) ? opt.variantesTallas : [];
    const vs = vars
      .map((v) => String(v?.name || v?.nombre || v?.descripcion || "").trim())
      .filter(Boolean)
      .join(", ");

    return vs ? `${base} (${vs})` : base;
  }}

  renderOption={(option) => {
    // "Dar de alta ..."
    if (option?.title) return option.title;

    const base =
      String(option?.name || option?.nombre || "").trim() ||
      String(option?.idTalla || "").trim();

    const vars = Array.isArray(option?.variantesTallas) ? option.variantesTallas : [];
    const vs = vars
      .map((v) => String(v?.name || v?.nombre || v?.descripcion || "").trim())
      .filter(Boolean)
      .join(", ");

    return (
      <React.Fragment>
        {base}
        {vs ? (
          <>
            {" "}
            <span className="text-muted">({vs})</span>
          </>
        ) : null}
      </React.Fragment>
    );
  }}

  onChange={(e, newValue) => {
    if (!newValue) return;

    // si eligió "Dar de alta"
    if (newValue?.inputValue) {
      openNuevaTalla(inputField.id, newValue.inputValue);
      return;
    }

    // si por alguna razón llega string
    if (typeof newValue === "string") {
      openNuevaTalla(inputField.id, newValue);
      return;
    }

    // si eligió una talla normal
    addTallaToRenglon(inputField.id, newValue);
  }}

  renderInput={(params) => (
    <TextField
      {...params}
      label="Agregar talla"
      variant="outlined"
      placeholder="Busca o escribe para darla de alta"
    />
  )}
  disabled={!inputField.articulos}
/>

</div>

</Col>
</Row>
{/* Tallas por color debajo */}
{(colores || [])
// {(inputField.arrayColoresArticulo || [])
  .filter(col => (inputField.selectedColores || []).includes(String(col._id)))
  .map((col) => {
    const totalColor = sumCantidadByColor(inputField.tc, col._id);
    const precioUnit = Number(inputField.precio) || 0;
    const importeColor = totalColor * precioUnit;

    return (
      <Row key={col._id} className="align-items-center mb-1 ps-3">
        <Col md={2} className="d-flex flex-column">
          <strong>{col.name || col.nombre}</strong>
          <small className="text-muted">
            Total color: <b>{totalColor}</b>
            {precioUnit > 0 && <> • {fmtUSD(importeColor)}</>}
          </small>
        </Col>

        <Col md={10}>
          <Row>
            {inputField.tc
              .filter(a => String(a.colores) === String(col._id))
              .map((a) => (
                <Col
                  key={`${a.tallas}-${a.tallaNombre}-${a.colores}`}
                  md="auto"
                  className="text-center"
                >
                  <Label>{a.tallaNombre}</Label>
                  <Input
                    bsSize="sm"
                    name="cantidad"
                    type="number"
                    value={a.cantidad}
                    onChange={(event) =>
                      handleChangeInputCantidad(inputField.id, a.colores, a.tallas, event)
                    }
                    style={{ width: "60px" }}
                  />
                </Col>
              ))}
          </Row>
        </Col>
        
      </Row>
    );
  })}
<Row>
  <Col>
         <Button
                      size="sm"
                      color="info"
                      onClick={handleAddFields}
                      tabIndex="-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
</Row>


              </div>
            ))}

            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoPedidos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
          <Modal size="xl" isOpen={modalExplosiones} toggle={toggleExplosiones}>
            <ModalHeader toggle={toggleExplosiones}>
              <h4>Explosion Modelo</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col md={3}>
                  <Label>Tela</Label>
                </Col>
                <Col md={2}>
                  <Label>Color</Label>
                </Col>
                <Col md={2}>
                  <Label>Metros Totales</Label>
                </Col>
                <Col md={3}>
                  <Label>Observaciones</Label>
                </Col>
              </Row>

              {inputFieldsTela.map((a) => (
                <div key={a.id}>
                  <Row>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="idTela"
                        type="select"
                        value={a.idTela}
                        required
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {telas
                          .filter((t) => t.is_active !== "No" || t._id === a.idTela)
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.nombre} / {a.tiposTelas[0].name}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="idColor"
                        type="select"
                        value={a.idColor}
                        required
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      >
                        <option value="">Selecciona</option>
                        {colores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        value={a.cantidad}
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      ></Input>
                    </Col>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="observaciones"
                        type="text"
                        value={a.observaciones}
                        onChange={(event) => {
                          handleChangeInputTela(a.id, event);
                        }}
                      ></Input>
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFieldsTela.length === 1}
                        onClick={() => handleRemoveFieldsTelas(a.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={handleAddFieldsTelas}
                        tabindex="-1"
                      >
                        <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <br />
            </ModalBody>
          </Modal>

          <Modal isOpen={modalNuevaTalla} toggle={() => setModalNuevaTalla(!modalNuevaTalla)}>
  <ModalHeader toggle={() => setModalNuevaTalla(!modalNuevaTalla)}>
    Dar de alta talla
  </ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label>Nombre de la talla</Label>
      <Input
        value={nuevaTallaNombre}
        onChange={(e) => setNuevaTallaNombre(e.target.value)}
        placeholder='Ej. "2XG", "CH", "30", etc.'
      />

       <Label for="exampleEmail" className="mr-sm-2">
                      Variante (opcional)
                    </Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={variante}
                      onChange={(e) => {
                        setVariante(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {variantesTallas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
    </FormGroup>

    <div className="d-flex gap-2">
      <Button
        color="primary"
        onClick={guardarNuevaTalla}
        disabled={savingTalla || !String(nuevaTallaNombre || "").trim()}
      >
        {savingTalla ? "Guardando..." : "Guardar"}
      </Button>

      <Button
        color="secondary"
        onClick={() => setModalNuevaTalla(false)}
        disabled={savingTalla}
      >
        Cancelar
      </Button>
    </div>
  </ModalBody>
</Modal>

<Modal isOpen={modalNuevoColor} toggle={() => setModalNuevoColor(!modalNuevoColor)}>
  <ModalHeader toggle={() => setModalNuevoColor(!modalNuevoColor)}>
    Dar de alta color
  </ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label>Nombre del color</Label>
      <Input
        value={nuevoColorNombre}
        onChange={(e) => setNuevoColorNombre(e.target.value)}
        placeholder='Ej. "Negro", "Rojo", "Azul Marino"'
      />
    </FormGroup>

    <div className="d-flex gap-2">
      <Button
        color="primary"
        onClick={guardarNuevoColor}
        disabled={savingColor || !String(nuevoColorNombre || "").trim()}
      >
        {savingColor ? "Guardando..." : "Guardar"}
      </Button>

      <Button
        color="secondary"
        onClick={() => setModalNuevoColor(false)}
        disabled={savingColor}
      >
        Cancelar
      </Button>
    </div>
  </ModalBody>
</Modal>

<Modal isOpen={modalNuevaTela} toggle={() => setModalNuevaTela(!modalNuevaTela)}>
  <ModalHeader toggle={() => setModalNuevaTela(!modalNuevaTela)}>
    Dar de alta tela
  </ModalHeader>
  <ModalBody>
    <FormGroup>
      <Label>Nombre</Label>
      <Input
        value={nuevaTela.nombre}
        onChange={(e) => {
          const val = e.target.value;
          setNuevaTela((prev) => ({ ...prev, nombre: val }));
        }}
        placeholder='Ej. "Algodón gris"'
      />
    </FormGroup>
    <FormGroup>
      <Label>Composición</Label>
      <Input
        value={nuevaTela.composicion}
        onChange={(e) => {
          const val = e.target.value;
          setNuevaTela((prev) => ({ ...prev, composicion: val }));
        }}
        placeholder='Ej. "100% algodón"'
      />
    </FormGroup>
    <FormGroup>
      <Label>Tipo de tela</Label>
      <Input
        type="select"
        value={nuevaTela.tipoTela}
        onChange={(e) => {
          const val = e.target.value;
          setNuevaTela((prev) => ({ ...prev, tipoTela: val }));
        }}
      >
        <option value="">Selecciona</option>
        {tiposTelas
          .slice()
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((t) => (
            <option value={t._id} key={t._id}>
              {t.name}
            </option>
          ))}
      </Input>
    </FormGroup>
    <small className="text-muted">
      Los demás campos (ancho, peso, costo, etc.) se podrán editar después en
      el catálogo de Telas.
    </small>
    <div className="d-flex gap-2 mt-3">
      <Button
        color="primary"
        onClick={guardarNuevaTela}
        disabled={
          savingTela ||
          !String(nuevaTela.nombre || "").trim() ||
          !String(nuevaTela.composicion || "").trim() ||
          !String(nuevaTela.tipoTela || "").trim()
        }
      >
        {savingTela ? "Guardando..." : "Guardar"}
      </Button>
      <Button
        color="secondary"
        onClick={() => setModalNuevaTela(false)}
        disabled={savingTela}
      >
        Cancelar
      </Button>
    </div>
  </ModalBody>
</Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default PedidosCreate;
